import postCard from "../assets/postcard-(2).png";
import digital from "../assets/digital-marketing.png";
import email from "../assets/orangemail.png";
import marketing from "../assets/social-marketing.png";

const FeautureSection = () => {
  const marketingItems = [
    {
      icon: postCard,
      title: "Direct",
      title2: "Mail",
      description:
        "Use the list to start direct outreach by phone. Talk to office managers, facility directors, or property owners ready to hire.",
    },
    {
      icon: digital,
      title: "Digital",
      title2: "Marketing",
      description:
        "Know your ideal customer better. Use our data to inspire blogs, make new website landing pages, and create resources like office cleaning checklists that attract your buyers.",
    },
    {
      icon: email,
      title: "Email",
      title2: "Deployment",
      description:
        "Craft personalized email campaigns to generate interest and schedule quotes. With updated contacts, your outreach will hit the mark.",
    },
    {
      icon: marketing,
      title: "Social Media",
      title2: "Marketing",
      description:
        "Upload the list into platforms like Facebook or LinkedIn to run hyper-targeted ads or direct messages.",
    },
  ];

  return (
    <div className="py-16 bg-[#E5E5E5]">
      <div className="px-5 md:py-0 md:px-0 max-w-6xl mx-auto">
        <div className="text-center mb-12">
          <p className="text-2xl font-bold text-[#4E6978] mb-4">
            We can do <span className="text-[#F09900]"> more </span> with your{" "}
            <span className="text-[#F09900]"> list</span>.
          </p>
          <div className="mt-4">
            <p className="text-xl text-[#4E6978] leading-8">
              Our marketing experts can take your list to the next level with
              the following extra services we <br /> offer.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 gap-4 md:grid-cols-2 md:gap-2 lg:grid-cols-4">
          {marketingItems.map((item, index) => (
            <div
              key={index}
              className="text-center border-2 border-[#4E6978] bg-[#F8F8F8] shadow-xl p-3 rounded-sm"
            >
              <div className="w-28 h-28 rounded-full flex items-center justify-center mx-auto mb-4">
                <img src={item.icon} width={300} />
              </div>
              <div className="my-9">
                <p className="text-xl font-bold text-[#4E6978] mb-2">
                  {item.title}
                  <br />
                  {item.title2}
                </p>
              </div>
              <p className="text-gray-600 leading-6">{item.description}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FeautureSection;
